

( function( $ ) {

   $( function () {
      mobile_nav();
   });

   function mobile_nav() {
      let isClicking = false;

      $('#nav_toggle')
      .on('mousedown', function () {
         isClicking = true;
      })
      .on('mouseup', function () {
         setTimeout(() => (isClicking = false), 100);
      })
      .on('click', function (event) {
         $('body').toggleClass('mainnav_open');
      })
      .on('focus', function () {
         if (!isClicking) {
            $('body').addClass('mainnav_open');
         }
      })
      .on('blur', function () {
         if (!isClicking) {
            $('body').removeClass('mainnav_open');
         }
      });


      $('#header_nav').on('focusin', 'a', function() {
         $('body').addClass('mainnav_open');
      });
      $('#header_nav').on('focusout', 'a', function() {
         $('body').removeClass('mainnav_open');
      });


      $('#content, #footer').on('click', function (service) {
         $('body').removeClass('mainnav_open');
      });


      $(window).on("resize", function () {
         if( $('body').hasClass('mainnav_open')  && !$('#nav_toggle').is(':visible')) {
            $('body').removeClass('mainnav_open');
         }
      });


      $('#main-nav li a').on('click', function () {
         const href = $(this).attr('href');

         if (href.startsWith('#')) {
               $('body').removeClass('mainnav_open');
         }
      });


   }





} )( jQuery );
